import React, { useEffect, useState } from "react";
import { Dialog, DialogType, TextField, Stack, Dropdown, IDropdownOption, PrimaryButton, Text, Image } from "@fluentui/react";

export interface LoginPopupProps {
    loginDomains: string[];
    onLoginButtonClicked: (loginHint: string) => void;
};

const LoginPopup: React.FC<LoginPopupProps> = props => {

    const [login, setLogin] = useState<string>("");
    const [domain, setDomain] = useState<string>(props.loginDomains[0]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        document.title = "CUK Raporty | Logowanie";
    }, []);

    const domainOptions = props.loginDomains.map((domain) : IDropdownOption => ({
        key: domain,
        text: domain
    }));

    const onFormSubmitted = () => {
        setLoading(true);
        props.onLoginButtonClicked(login.includes("@") ? login : `${login}@${domain}`);
    };

    return (
        <Dialog hidden={false} dialogContentProps={{ type: DialogType.normal, styles: {header: { display: "none" }} }}>
            <form onSubmit={e => { e.preventDefault(); onFormSubmitted(); }} style={{marginTop: 20}}>
                <Stack tokens={{childrenGap: 20}}>
                    <Stack horizontalAlign="center">
                        <Image src="/logo.svg" height={150} />
                    </Stack>
                    <Stack tokens={{childrenGap: 10}} horizontalAlign="center">
                        <Text>Zaloguj się w domenie</Text>
                        <Text><strong>@cuk.pl</strong> lub <strong>@partner.cuk.pl</strong></Text>
                        <Text>aby wyświetlić raport</Text>
                    </Stack>
                    <Stack horizontal>
                        <TextField value={login} required placeholder="np. 'j.kowalski'" suffix="@" onChange={(_, value) => setLogin(value)} disabled={loading} /> 
                        <Dropdown selectedKey={domain} options={domainOptions} dropdownWidth="auto" onChange={(_e, option) => setDomain(option.key as string)} />
                    </Stack>
                    <PrimaryButton type="submit" disabled={loading || login.length === 0}>Kontynuuj</PrimaryButton>
                </Stack>
            </form>
        </Dialog>
    );
};

export default LoginPopup;